(function (angular) {
    angular.module('app.auth', []);

}(angular));